module.exports = __webpack_public_path__ + "media/images/badge-new-000d98c8566f0829157680e7289571c8.svg";